import { Rank } from '../../sim/defs';
import { Fam } from '../../sim/pools/BulletPool';
import { defineEnemy, Motion, Pattern } from '../schema';

/** E05 — RÔDEUR. Le contrepoint du Faucheur.
 *
 *  Traverse latéralement et tire un éventail STATIQUE de 5 projectiles,
 *  indépendant de la position du joueur. C'est là toute sa raison d'être : ses
 *  tirs créent des ZONES INTERDITES PRÉVISIBLES, là où le Faucheur crée une
 *  menace qui poursuit.
 *
 *  Le duo Faucheur + Rôdeur est la base de 60 % des vagues du plan, et ce n'est
 *  pas un hasard : un jeu où toutes les menaces suivent le joueur n'a pas de
 *  géographie, et le terrain cesse d'exister. Il faut les deux natures pour que
 *  se déplacer veuille dire quelque chose. */
export default defineEnemy({
  id: 'rodeur',
  rank: Rank.Standard,
  hp: 240,
  visualRadius: 30,
  score: 220,
  telegraph: 1.1,
  drops: 2,
  motion: { kind: Motion.Strafe, speed: 260, amplitude: 0, frequency: 0, holdY: 380 },
  emitter: {
    pattern: Pattern.Fan,
    every: 2,
    count: 5,
    spreadDeg: 40,
    speed: 380,
    firstDelay: 1.2,
    family: Fam.EnemyPurple,
  },
});

